import { giphyBlack } from '@giphy/js-brand'
import styled from 'styled-components'
import { LoggedInUser } from 'types'
import Giphy from './components/logo'

const margin = 6

const containerPadding = `${margin * 2}px 0 ${margin}px ${margin}px;`

const Container = styled.div`
    position: relative;
    z-index: 1001;
    padding: ${containerPadding};
    background: ${giphyBlack};
`

const Header = ({ user }: { user: LoggedInUser }) => {
    return (
        <Container>
            <Giphy />
            <div>Welcome {user ? user.display_name : ''}</div>
        </Container>
    )
}
export { default as Logo } from './components/logo'
export { Header }
